import { Thread as UnifiedThread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/models.pb';
import { CachedResourceType, ResourceMatchingOptions } from '../types';

type CombinedResourceMatchFn<ResourceType extends CachedResourceType> = ({
  matchValues,
  matchFn,
  matchStrategy,
}: Omit<ResourceMatchingOptions<ResourceType>, 'updater'>) => (resource: ResourceType) => boolean;

export const combinedUnifiedThreadMatchFn: CombinedResourceMatchFn<UnifiedThread> =
  ({ matchValues, matchFn, matchStrategy = 'and' }) =>
  (thread) => {
    const isSimpleMatch = thread.id === matchValues.threadId;
    if (matchFn) {
      const matchFnResult = matchFn(thread);
      return matchStrategy === 'and' ? isSimpleMatch && matchFnResult : isSimpleMatch || matchFnResult;
    }

    return isSimpleMatch;
  };
